import * as React from "react"
import { useHostingDetailsForSiteQuery } from "@modules/cdn/gatsbyCloudCdn/queries.generated"
import { Heading, ThemeCss, visuallyHiddenCss } from "gatsby-interface"
import { SslCertificateDetails } from "../../shared/components/SslCertificateDetails"

const headingCss: ThemeCss = theme => ({
  fontSize: theme.fontSizes[3],
})

const tableCss: ThemeCss = theme => ({
  fontSize: theme.fontSizes[1],

  tr: {
    verticalAlign: `baseline`,
  },
  td: {
    border: 0,
  },
})

const listResetCss: ThemeCss = _theme => ({
  listStyle: `none`,
  margin: 0,
  padding: 0,
})

const hintCss: ThemeCss = theme => ({
  margin: 0,
  color: theme.colors.grey[60],
  fontSize: theme.fontSizes[0],
})

export type HostingDetailsProps = {
  siteId: string
}

export function HostingDetails({ siteId }: HostingDetailsProps) {
  const { data } = useHostingDetailsForSiteQuery({
    variables: {
      siteId,
    },
  })

  const details = data?.hostingDetailsForSite ?? []

  return (
    <React.Fragment>
      <Heading as="h3" css={headingCss}>
        Connected domains
      </Heading>
      <table css={tableCss}>
        <thead css={visuallyHiddenCss}>
          <tr>
            <td>Domain</td>
            <td>DNS information</td>
          </tr>
        </thead>
        <tbody>
          {details.map(detail => {
            const dnsEntries = detail.dns ?? []

            return (
              <React.Fragment key={detail.id}>
                <tr>
                  <td>
                    {detail.domains
                      ?.map(({ id: domainName }) => domainName)
                      .join(", ")}
                  </td>
                  <td>
                    <ul css={listResetCss}>
                      {dnsEntries.map(dns => {
                        return (
                          <li key={dns.id}>
                            {dns.type} {dns.id}
                            <p css={hintCss}>
                              Please use this {dns.type} record with your DNS
                              provider
                            </p>
                          </li>
                        )
                      })}
                    </ul>
                  </td>
                </tr>
                {detail.certificates?.map(cert => {
                  return (
                    <tr key={cert.id}>
                      <td
                        colSpan={2}
                        css={theme => ({
                          borderTop: `1px solid ${theme.colors.grey[30]} !important`,
                        })}
                      >
                        <SslCertificateDetails certificate={cert} />
                      </td>
                    </tr>
                  )
                })}
              </React.Fragment>
            )
          })}
        </tbody>
      </table>
    </React.Fragment>
  )
}
